<template>
  <section class="deductible">
    <div class="container">
      <div
        class="left aos-init aos-animate"
        data-aos="fade-right"
        data-aos-duration="2000"
      >
        <h2>Get a low deductible with unlimited claims</h2>
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon4.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>

              <td>
                <h3>Why does a student need Renters Insurance?</h3>
                <p>
                  Replacing a new TV, laptop, furniture, and appliances can be
                  pricey without insurance. Even small incidents can quickly add
                  up.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!------------->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon5.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>

              <td>
                <h3>Repair or replacement when things happen</h3>
                <p>
                  If your claim is approved, we’ll reimburse you for what it
                  costs to repair or replace your things.
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!------------->
        <table
          width="100%"
          border="0"
          cellspacing="0"
          cellpadding="0"
          class="bullet"
        >
          <tbody>
            <tr>
              <td class="bulleticon" width="19%" valign="top">
                <img
                  loading="lazy"
                  :src="require('@/assets/images/icon6.svg')"
                  width="115"
                  height="114"
                  alt="Caption"
                />
              </td>

              <td>
                <h3>Meet your lease agreement requirements</h3>
                <p>
                  Provide proof of coverage to your landlord or housing
                  director. Plus, give yourself some peace of mind!
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <!------------->
      </div>
      <div style="clear: both"></div>
    </div>
  </section>
</template>
